import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export type DistrictListQueryParams = Parameters<typeof SSF.api.districtsList>[0];
export type DistrictListOrdering = Exclude<DistrictListQueryParams, undefined>['ordering'];

export const keys = createQueryKeySet<DistrictListQueryParams>('districts');

export function useDistrictListQuery(params?: DistrictListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.districtsList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}

export function useDistrictQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.districtsRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
  });
}
